import { outcomeMessage } from '../GameOver/outcomeMessage';

/**
 * How a game in the list reads for the player: who it is against and where it stands. Whether it's waiting on them,
 * and for what, is the server's answer (`waiting_on_you`), the same one notifications and the app icon's count use.
 * `newMoves`: how many of the other player's moves you haven't seen (the server's `seen`).
 */
export function gameSummary(game, userId) {
  const opponent = (game.get('users') || [])
    .find(user => user.get('id') !== userId);
  const against = opponent ? `vs ${opponent.get('name')}` : `Game ${game.get('id')}`;
  const newMoves = game.getIn(['seen', 'new_moves']) || 0;

  const outcome = outcomeMessage(game, userId);
  if (outcome) {
    return { against, opponent, newMoves, status: outcome.title, yourMove: false };
  }

  const waiting = game.get('waiting_on_you');
  if (waiting) {
    return { against, opponent, newMoves, status: waiting, yourMove: true };
  }

  return { against, opponent, newMoves, status: game.get('active_player_id') ? 'Their turn' : 'Setting up', yourMove: false };
}

/** How many of the games are waiting on the player, for the app icon's count. */
export const waitingCount = (games) => games.filter(game => !game.get('ended_at') && game.get('waiting_on_you')).size;
